
const NoneLayout = ({children}:any) => {

    return(
        <section>{children}</section>
    )
}
export default NoneLayout;